var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
    _c(
      "div",
      [
        _vm.summary_page ? _c("summary-page") : _vm._e(),
        _vm._v(" "),
        _c("loading-screen", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading && !_vm.summary_page,
              expression: "loading && !summary_page"
            }
          ]
        }),
        _vm._v(" "),
        _c("main-view", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading && !_vm.summary_page && !_vm.client_page,
              expression: "!loading && !summary_page && !client_page"
            }
          ]
        }),
        _vm._v(" "),
        _c("client-main-view", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.client_page,
              expression: "client_page"
            }
          ]
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 